import React from 'react';
import FormControl from '@mui/material/FormControl';
import { IProps } from './IProps';

const Component: React.FC<IProps> = ({ children }: IProps) => {
    return (
        <FormControl className="modal__form" component="form">
            {children}
        </FormControl>
    );
};

const ModalFormComponent = React.memo(Component);

export default ModalFormComponent;
